<template>
  <div class="miss">
    <div class="icon">
      <img src="https://web-data.zmlearn.com/image/g1NTMGxiRBnqwiXp4XPsWr/birthday.png" />
    </div>
    <div class="desc">
      <div class="name">{{info.personName}}</div>
      <div class="date">生日：{{info.birthday|formatShortDate('MM月dd日')}}</div>
      <div class="expes">过期时间：{{info.validityDay|formatDate}}</div>
    </div>
  </div>
</template>

<script>
import { formatDate, formatShortDate } from '@/utils/date.js';

export default {
  props: ['info'],
  filters: {
    formatDate,
    formatShortDate,
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.miss {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  .icon {
    & > img {
      width: 80px;
    }
  }
  .desc {
    margin-left: 10px;
    .name {
      font-weight: bold;
      font-size: 28px;
    }
    .date {
      font-size: 26px;
    }
    .expes {
      margin-top: 10px;
      font-size: 22px;
      color: #ff7820;
    }
  }
}
.miss::after {
  content: '';
  width: 100px;
  height: 100px;
  position: absolute;
  right: 20px;
  opacity: 0.5;
  background-image: url('https://web-data.zmlearn.com/image/kU9VpdXdyzvYe9DeUK9h5N/expire.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>